import { render, staticRenderFns } from "./HoldConstructor.vue?vue&type=template&id=9eb6b288&"
import script from "./HoldConstructor.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HoldConstructor.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./HoldConstructor.vue?vue&type=style&index=0&id=9eb6b288&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports